export type WeekStartDay = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export const DEFAULT_WEEK_START: WeekStartDay = 1;

export const HR_CALENDAR_MAX_TAGS = 3;

export const DAYS_IN_WEEK = 7;

export interface HrCalendarDay {
  date: Date;
  isoDate: string;
  dayOfMonth: number;
  dayOfWeek: number;
  inMonth: boolean;
  isWeekend: boolean;
  isToday: boolean;
}

export interface HrCalendarWeek {
  days: HrCalendarDay[];
}

export interface HrCalendarMonth {
  viewDate: Date;
  weekdays: number[];
  weeks: HrCalendarWeek[];
}

export type HrCalendarTagVariant = 'neutral' | 'info' | 'success' | 'waiting' | 'attention';

export interface HrCalendarTag {
  label: string;
  variant?: HrCalendarTagVariant;
  tooltip?: string;
}

export type HrCalendarTagsByDate = Record<string, HrCalendarTag[]>;

export const WORK_SCHEDULE_GROUP_NAME = 'ContractWorkTime';

export enum WorkScheduleWeekdayZone {
  Sunday = 'Sunday',
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday'
}

export interface HrCalendarWorkSchedule {
  beginDate?: string;
  endDate?: string;
  hoursByWeekday: Array<number | null>;
}

export interface HrCalendarWorkScheduleDay {
  isWorkingDay: boolean;
  hours: number | null;
}

export type HrCalendarWorkScheduleByDate = Record<string, HrCalendarWorkScheduleDay>;

export interface HrCalendarContractPeriod {
  begindate?: string;
  enddate?: string;
}

